














import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'UCSwitch',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onChange(value: boolean) {
      this.$emit('input', !value);
    },
  },
});
